export const HeaderFilterHeight = '325';
export const HeaderFilterWidth = '252';
export const EditDelay = 100;
